import { jsx } from "react/jsx-runtime";
import ArchiveIcon from "@mui/icons-material/Archive";
import { validateTidalLicense } from "../../base/index.js";
function Archive(props) {
  return /* @__PURE__ */ jsx(
    ArchiveIcon,
    {
      "data-testid": "Archive",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Archive",
      "data-tidal-icon-meta": "fileActions"
    }
  );
}
Archive.tidalIconMeta = {
  categories: "fileActions",
  name: "Archive"
};
validateTidalLicense();
export {
  Archive
};
//# sourceMappingURL=Archive.js.map
